import BookkeepingFilter from "components/filters/Filters/BookkeepingFilter";
import ContactFilter from "components/filters/Filters/ContactFilter";
import { InvoiceSortFilter } from "components/filters/Filters/SortFilter";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import OwnersFilter from "components/filters/Filters/OwnersFilter";
import PeriodFilter from "components/filters/Filters/PeriodFilter";
import CompanyFilter from "components/filters/Filters/CompanyFilter";
import StatusFilter from "components/filters/Filters/StatusFilter";
import React from "react";
import CostCenterFilter from "components/filters/Filters/CostCenterFilter";
import InvoiceProgressFilter from "components/filters/Filters/InvoiceProgressFilter";
import OnlyMySelectionFilter from "components/filters/Filters/OnlyMySelectionFilter";

interface FiltersProps {
  initialStatuses: server.dto.StatusSmall[]
}

const Filters = (props: FiltersProps) => {
  return <>
    <KeywordFilter
      label={RESX.GeneralLabels.Number}
      title={RESX.InvoiceDocument.InvoiceNumber}
      placeholder={RESX.Document.DocumentNumberPlaceHolder}
    />
    <CompanyFilter
      title={RESX.Document.Addressee}
    />
    <ContactFilter />
    <InvoiceProgressFilter />
    <BookkeepingFilter />
    <CostCenterFilter />
    {(props.initialStatuses.length > 1 && site.currentEnvironment.invoice.hasV1) && (
      <StatusFilter initialStatuses={props.initialStatuses} />)}
    <OwnersFilter />
    <PeriodFilter targets={["sendDate", "dueDate"]} />
    <InvoiceSortFilter />
    <OnlyMySelectionFilter />
  </>;
};

export default Filters;